var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9094 40.5H6.09126C3.09126 40.5 0.636719 38.0455 0.636719 35.0455V5.95455C0.636719 2.95455 3.09126 0.5 6.09126 0.5H20.6367C21.1276 0.5 21.5822 0.7 21.9276 1.02727L32.8367 11.9364C33.1822 12.2818 33.364 12.7364 33.364 13.2273V35.0455C33.364 38.0455 30.9094 40.5 27.9094 40.5ZM6.09126 4.13636C5.09126 4.13636 4.27308 4.95455 4.27308 5.95455V35.0455C4.27308 36.0455 5.09126 36.8636 6.09126 36.8636H27.9094C28.9094 36.8636 29.7276 36.0455 29.7276 35.0455V13.9727L19.8913 4.13636H6.09126Z",
    fill: "#20262D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5458 15.0455H20.6367C19.6367 15.0455 18.8185 14.2273 18.8185 13.2273V2.31818C18.8185 1.31818 19.6367 0.5 20.6367 0.5C21.6367 0.5 22.4549 1.31818 22.4549 2.31818V11.4091H31.5458C32.5458 11.4091 33.364 12.2273 33.364 13.2273C33.364 14.2273 32.5458 15.0455 31.5458 15.0455Z",
    fill: "#20262D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4549 27.7727H11.5458C10.5458 27.7727 9.72763 26.9545 9.72763 25.9545C9.72763 24.9545 10.5458 24.1364 11.5458 24.1364H22.4549C23.4549 24.1364 24.2731 24.9545 24.2731 25.9545C24.2731 26.9545 23.4549 27.7727 22.4549 27.7727Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.7e2f008dd7f9fc9d69a36ebca09a40fe.svg";
export { ForwardRef as ReactComponent };